// Header.js
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/icons/small_icons/logo_header.svg";
import menu from "../assets/icons/small_icons/menu_header.svg";
import notificationsIcon from "../assets/icons/small_icons/notifications_header.svg";
import profile from "../assets/icons/small_icons/profile_header.svg";

import { notifications as getNotifications } from "../api/user";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [notificationsData, setNotificationsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const showBackButton = location.pathname !== "/";

  const fetchNotifications = async () => {
    try {
      const data = await getNotifications();
      setNotificationsData(data);
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        // window.location.href = "/";
        console.warn("User unauthorized for notifications.");
        setNotificationsData([]);
        return;
      }
      setError("Could not load notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    // fetch notifications every 15 minutes
    const interval = setInterval(fetchNotifications, 900000);

    return () => clearInterval(interval);
  }, []);

  const hasNotifications =
    notificationsData.length > 0 && location.pathname !== "/notifications";

  return (
    <header>
      <div className="row p-0 m-0 w-100">
        <div
          className="col d-flex justify-content-center align-items-center m-0 p-0"
          style={{ backgroundColor: "#01153a" }}
        >
          <div className="d-flex align-items-center my-2"></div>
        </div>
      </div>

      <div
        className="row m-0 p-0"
        style={{
          height: "8vh",
          backgroundColor: "#01153a",
          borderStyle: "none",
          borderColor: "#01153a",
        }}
      >
        {/* Left side - Brand */}
        <div className="col-6 d-flex justify-content-center align-items-center m-0 p-0">
          {showBackButton ? (
            <div
              className="d-flex justify-content-center align-items-center gap-2"
              style={{ cursor: "pointer", color: "white" }}
              onClick={() => navigate(-1)}
            >
              <span style={{ fontSize: "35px", lineHeight: "1" }}>←</span>
              <h4 className="m-0">REGRESAR</h4>
            </div>
          ) : (
            <Link to="/landing">
              <img src={logo} alt="Brand Logo" style={{ height: "40px" }} />
            </Link>
          )}
        </div>

        {/* Right side - Navigation icons */}
        <div className="col-6 m-0 pe-4 d-flex justify-content-end align-items-center gap-3">
          <Link to="/notifications" aria-label="Notifications">
            <img
              src={notificationsIcon}
              alt="notifications"
              style={{
                height: "24px",
                cursor: "pointer",
                filter: hasNotifications
                  ? "invert(18%) sepia(92%) saturate(5600%) hue-rotate(350deg)"
                  : "none",
              }}
            />
          </Link>

          <Link to="/personalData" aria-label="Profile">
            <img
              src={profile}
              alt="profile"
              style={{ height: "24px", cursor: "pointer" }}
            />
          </Link>

          <Link to="/menu" aria-label="Settings">
            <img
              src={menu}
              alt="menu"
              style={{ height: "24px", cursor: "pointer" }}
            />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;